var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{attrs:{"url":"donors","columns":_vm.columns,"title":_vm.title,"navigationPath":"DinnerAccountView","navigationField":"personID"}})}
var staticRenderFns = []

export { render, staticRenderFns }